/* eslint-disable */
import $ from 'jquery';
export class Hwb_pakketten {
  constructor() {
    this.$unfoldButton = $('.hwb-pakketten-collapse.unfold');
    this.$foldButton = $('.hwb-pakketten-collapse.fold');
    this.$hwbPakketten = $('.hwb-pakketten');

    // bind events
    this.$unfoldButton.on('click', () => this.unfold());
    this.$foldButton.on('click', () => this.fold());
  }

  unfold() {
    this.$unfoldButton.hide();
    this.$hwbPakketten.slideDown("slow");
  }

  fold() {
    this.$hwbPakketten.slideUp("slow");
    setTimeout(() => {
      this.$unfoldButton.show();
    }, 500);
  }
}
